import React from "react";
import EntrySectionCard from "../../Cards/EntrySectionCard";
import { Event } from "../../../models";
import { formatStartEndDatesStrings } from "../../../utilities/dates/FormatDates";
import { ExpandedCardStates } from "../NewEntry/newEntryTypes"; // Shared type — do not import from the route page.

/**
 * Event Info parent card on the New Entry page: event name, dates, and expand/collapse of the header section.
 */
interface EntryPageHeaderProps {
    event: Event;
    expandedCard: ExpandedCardStates;
    handleCollapseOrExpand: (card: ExpandedCardStates) => (isExpand: boolean) => void;
    /** Invoked when the user presses the card's Continue/Save button (closes the card). */
    onContinue: () => void;
    saveRequestKey?: number;
}

const EntryPageHeader: React.FC<EntryPageHeaderProps> = ({ event, expandedCard, handleCollapseOrExpand, onContinue, saveRequestKey = 0 }) => {
    const startDate = event.startDate;
    const endDate = event.endDate;
    const dateRange = startDate && endDate ? `${formatStartEndDatesStrings(startDate, endDate, "MMM D, YYYY")}` : `${startDate}`;

    return (
        <EntrySectionCard
            event={event}
            miniTitle={dateRange}
            title={event.name}
            chipTitle="Event Info"
            trashIcon={false}
            expandButtonTitle="View"
            isExpand={expandedCard === "header"}
            cardContent="header"
            toggleExpansion={handleCollapseOrExpand("header")}
            onSubmit={onContinue}
            leadingEmoji="📅"
            saveRequestKey={saveRequestKey}
        />
    );
};

export default EntryPageHeader;
